// material-ui
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';

import logoExtended from "../../../assets/images/paisley-logo-extended-white.png";
import logo from "../../../assets/images/paisley-logo-sm.png";
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 *
 *
 */

// ==============================|| LOGO SVG ||============================== //

const Logo = () => {
  const theme = useTheme();
  const location = useLocation();
  const leftDrawerOpened = useSelector((state) => state.session.menuVisible);
  const matchDownMd = useMediaQuery(theme.breakpoints.down("md"));
  
  // Check if we're on the login page
  const isLoginPage = location.pathname.includes('login') || location.pathname.includes('forgottenpassword') || location.pathname.includes('/register');

  return (
    /**
     * if you want to use image instead of svg uncomment following, and comment out <svg> element.
     *
     * <img src={logo} alt="Berry" width="100" />
     *
     */
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img
        src={isLoginPage ? logo : (matchDownMd || leftDrawerOpened ? logoExtended : logo)}
        alt="Paisley"
        height={isLoginPage ? "100" : "50"} // Increased height for login page
      />
    </div>
  );
};

export default Logo;
